<template>
  <div
    class="popup"
    :style="{ visibility: show ? 'unset' : 'hidden' }"
    ref="pop"
  >
    <div class="top">
      <div class="date">
        {{ this.$moment(form.date).format("dd, DD MMMM") }}
      </div>
      <button @click="close">
        <img src="@/assets/images/icons/close.svg" alt="close" />
      </button>
    </div>
    <div>
      <div class="timepicker">
        <div class="inp">
          <CustomInput type="time" step="1800" v-model="form.start" />
        </div>
        <span class="strip">-</span>
        <div class="inp">
          <CustomInput type="time" step="1800" v-model="form.end" />
        </div>
      </div>
      <error-text :text="errors.start_at || errors.end_at" />
    </div>
    <div v-if="!form.master">
      <CustomInput
        v-model="form.name"
        placeholder="Название"
        mb="10px"
        @change="errors.name = null"
      />
      <error-text :text="errors.name" />
    </div>
    <div v-if="!form.name">
      <div class="name">
        <CustomInput
          :value="masterName"
          placeholder="Мастер"
          v-debounce:300ms="loadMasters"
        />
        <div class="name__dropdown" v-if="masters.length">
          <div
            class="name__dropdown-item"
            v-for="(master, idx) in masters"
            :key="idx"
            @click="setMaster(master)"
          >
            <img
              height="50px"
              v-if="master.avatar"
              :src="master.avatar"
              alt=""
            />
            <div>
              <div class="title">{{ master.name }} {{ master.surname }}</div>
              <div class="phone">{{ master.phone }}</div>
            </div>
          </div>
        </div>
      </div>
      <error-text :text="errors.master_id" />
    </div>

    <button class="save" @click="confirm()" :disabled="confirming">
      Сохранить
    </button>
  </div>
</template>

<script>
import ErrorText from "@/components/ui/text/error-text";
import CustomInput from "@/components/ui/inputs/custom-input";
import moment from "moment";

export default {
  name: "CreationPopup",
  components: { CustomInput, ErrorText },
  props: {
    zone: Object,
  },
  data: () => ({
    masters: [],
    errors: {},
    confirming: false,
    form: {
      master: "",
      date: "",
      edate: "",
      start: "",
      end: "",
      resId: "",
      name: "",
    },
    edit: false,
    show: false,
  }),
  computed: {
    masterName() {
      return this.form.master
        ? `${this.form.master.name} ${this.form.master.surname}`
        : null;
    },
  },
  methods: {
    getDate(date, time) {
      if (!date || !time) return "";
      return moment(date, "YYYY-MM-DD")
        .set("hours", time.split(":")[0])
        .set("minutes", time.split(":")[1])
        .format("YYYY-MM-DD HH:mm:ss");
    },
    setMaster(master) {
      this.form.master = master;
      this.masters = [];
      this.errors.master_id = null;
    },
    loadMasters(search) {
      this.masters = [];
      this.$api.admin.master
        .list({ perPage: 100, search })
        .then(({ data }) => (this.masters = data));
    },
    create() {
      this.confirming = true;
      console.log(this.form);
      this.$api.admin.rent
        .create({
          master_id: this.form.master ? this.form.master.id : "",
          zone_id: this.zone.id,
          start_at: this.getDate(this.form.date, this.form.start),
          end_at: this.getDate(this.form.edate, this.form.end),
          workplace_id: this.form.resId,
          name: this.form.master ? null : this.form.name,
        })
        .then(() => {
          this.$toast.success("Аренда успешно создана!");
          this.$eventHub.$emit("rent.changed");
          this.close();
        })
        .catch(({ response }) => {
          this.errors = response.data.errors;
        })
        .finally(() => (this.confirming = false));
    },
    update() {
      this.confirming = true;
      this.$api.admin.rent
        .update(this.form.id, {
          master_id: this.form.master ? this.form.master.id : "",
          zone_id: this.zone.id,
          start_at: this.getDate(this.form.date, this.form.start),
          end_at: this.getDate(this.form.edate, this.form.end),
          workplace_id: this.form.resId,
          name: this.form.master ? null : this.form.name,
        })
        .then(() => {
          this.$toast.success("Сохранено!");
          this.$eventHub.$emit("rent.changed");
          this.close();
        })
        .catch(({ response }) => {
          this.errors = response.data.errors;
        })
        .finally(() => (this.confirming = false));
    },
    confirm() {
      this.edit ? this.update() : this.create();
    },
    open(e, edit = false) {
      let start = e.event ? e.event.start : e.startStr;
      // let end = e.event ? e.event.end : e.endStr;
      if (moment(start).diff(moment(), "minutes") <= 0)
        return this.$toast.error(
          "Невозможно создать запись на прошедшую дату!"
        );

      this.edit = edit;
      this.clear();
      //offsets section
      let w = this.$refs.pop.offsetWidth;
      let h = this.$refs.pop.offsetHeight;
      let left = Math.abs(
        e.jsEvent.x - e.jsEvent.layerX + e.jsEvent.target.clientWidth + w
      );
      let offset = 10;
      let lofSet = document.body.clientWidth - left;
      if (lofSet > 0) {
        lofSet = offset;
      } else {
        lofSet = -e.jsEvent.target.clientWidth - w - offset;
      }
      left -= w;
      let scrY = window.scrollY;
      if (
        document.body.offsetHeight <
        e.jsEvent.y - e.jsEvent.layerY + window.scrollY + h
      )
        scrY = -h + e.jsEvent.target.clientHeight + window.scrollY;
      //offsets end
      //coords section
      const popLeft = Math.max(left + lofSet, 0);
      this.$refs.pop.style.left = popLeft + "px";
      this.$refs.pop.style.top =
        Math.abs(e.jsEvent.y - e.jsEvent.layerY + scrY) + "px";
      //coords end
      if (edit) {
        this.form.date = this.$moment(e.event.start).format("YYYY-MM-DD");
        this.form.edate = this.$moment(e.event.end).format("YYYY-MM-DD");
        this.form.start = this.$moment(e.event.start).format("HH:mm");
        this.form.end = this.$moment(e.event.end).format("HH:mm");
        this.form.id = e.event.id;
        this.form.master = e.event.extendedProps.master;
        this.form.name = e.event.extendedProps.name;
        this.form.resId = e.event.extendedProps.workplaces[0].id;
      } else {
        this.form.date = this.$moment(e.start).format("YYYY-MM-DD");
        this.form.edate = this.$moment(e.end).format("YYYY-MM-DD");
        this.form.start = this.$moment(e.start).format("HH:mm");
        this.form.end = this.$moment(e.end).format("HH:mm");
        this.form.resId = e.resource.id;
      }
      this.$emit("opened");
      this.show = true;
    },
    clear() {
      this.form.date = null;
      this.form.start = null;
      this.form.end = null;
      this.form.name = null;
    },
    close() {
      this.show = false;
    },
  },
};
</script>

<style scoped lang="scss">
.popup {
  display: inline-block;
  z-index: 100;
  position: absolute;
  left: 0;
  top: 230px;
  background-color: #ffffff;
  border: 2px solid #dbbfa7;
  border-radius: 5px;
  padding: 15px 20px 20px 20px;
  max-width: 365px;
  width: 100%;
}

.top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  button {
    background-color: transparent;
    border: none;
    width: 20px;
    height: 20px;

    img {
      max-width: 100%;
    }
  }

  .date {
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 1.7;
    color: #808080;
  }
}

.timepicker {
  display: flex;
  align-items: center;
  margin-bottom: 15px;

  .inp {
    width: 100px;
  }

  .strip {
    margin: 0 5px;
  }
}

.name {
  position: relative;

  &__dropdown {
    z-index: 2;
    position: absolute;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.04), 0 2px 6px rgba(0, 0, 0, 0.04),
      0 0 1px rgba(0, 0, 0, 0.04);
    right: 0;
    left: 0;
    top: 52px;
    border: 1px solid #dbbfa7;
    border-radius: 5px;
    overflow: hidden;

    &-item {
      display: flex;
      align-items: center;
      padding: 10px 15px;
      border-bottom: 1px solid #e5e5e5;
      background-color: #fff;
      cursor: pointer;

      img {
        margin-right: 10px;
      }

      .title {
        font-size: 16px;
        line-height: 1.5;
        color: #383838;
      }

      .phone {
        font-size: 14px;
        line-height: 1.7;
        color: #808080;
      }
    }
  }
}

.save {
  height: 48px;
  margin-left: -22px;
  margin-right: -22px;
  width: calc(100% + 44px);
  margin-bottom: -2px;
  transform: translateY(20px);
  border: 2px solid #dbbfa7;
  background-color: #fff;
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #808080;
}
</style>
